<template>
	<JBox class="s-bg-gray-100 s-min-h-screen">
		<CMainMenuHorizontal v-if="isMenuDisplayed" />

		<!-- View -->
		<JBox class="s-w-full">
			<RouterView />
		</JBox>

		<!-- Layers -->
		<PortalTarget name="layer0" />
		<PortalTarget name="layer1" />
		<PortalTarget name="layer2" />
		<PortalTarget name="layer3" />
		<PortalTarget name="layer4" />
		<PortalTarget name="layer5" />
		<CMessage />
	</JBox>
</template>

<script>
import CMainMenuHorizontal from "@/modules/core/components/CMainMenuHorizontal"

export default {
	components: { CMainMenuHorizontal },

	computed: {
		isMenuDisplayed() {
			if (
				this.$route.name === "ViewUiEditorHome" ||
				this.$route.name === "ViewAuthLogin" ||
				this.$route.name === "ViewTemplatesSms" ||
				this.$route.name === "ViewTemplatesPdfDrawing" ||
				this.$route.name === "ViewTemplatesWkhtml" ||
				this.$route.name === "ViewTemplatesNotification" ||
				this.$route.name === "ViewTemplatesEmailMjml" ||
				this.$route.name === "ViewTemplatesDynamic" ||
				this.$route.name === "ViewTemplatesFunction" ||
				this.$route.name === "ViewProductsPricing" ||
				this.$route.name === "ViewProductsUnderwriting" ||
				this.$route.name === "ViewProductsBenefits" ||
				this.$route.name === "ViewAppsConfig"
			)
				return false
			return true
		}
	}
}
</script>
